import { render, staticRenderFns } from "./IconChevronDownAlt.vue?vue&type=template&id=aa8e89c0&"
import script from "./IconChevronDownAlt.vue?vue&type=script&lang=js&"
export * from "./IconChevronDownAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports